import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactSelect from 'react-select';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import _map from 'lodash/map';
import _omit from 'lodash/omit';

// Styles
import styles from './SelectField.styl';

const cx = classNames.bind(styles);

class SelectField extends Component {
  handleSelect = val => {
    const { onChange, onSelect } = this.props;

    const value = val?.target?.value || val;

    onChange(value);
    onSelect(value);
  };

  render() {
    const {
      isPhone,
      className,
      children,
      label,
      name,
      required,
      _ref,
      isSearchable,
      description,
      ...otherProps
    } = this.props;

    const selectProps = _omit(
      {
        ...otherProps,
        id: name,
        name,
      },
      ['dispatch'],
    );

    return (
      <div className={cx('SelectField', className, { SelectField_disabled: otherProps.disabled })}>
        {Boolean(label) && (
          <label className={cx('SelectField__label')} htmlFor={name}>
            {label} {required && '*'}
          </label>
        )}
        <div className={cx('SelectField__selectWrapper')}>
          <FormattedMessage id="field.select.noResult">
            {text => (
              <FormattedMessage id="field.select.placeholder">
                {defaultPlaceholder => (
                  <>
                    {!isPhone ? (
                      <ReactSelect
                        {...selectProps}
                        className={cx('SelectField__field')}
                        ref={_ref}
                        onChange={this.handleSelect}
                        isSearchable={isSearchable}
                        noResultsText={text}
                        instanceId={name}
                        clearable={false}
                        autosize={false}
                        autoBlur
                        simpleValue
                        placeholder={selectProps.placeholder || defaultPlaceholder}
                      />
                    ) : (
                      <div className={cx('SelectField__field')}>
                        <select
                          {...selectProps}
                          className="Select-control"
                          onBlur={this.handleSelect}
                          ref={_ref}
                          placeholder={selectProps.placeholder || defaultPlaceholder}
                        >
                          {_map(selectProps.options, (item, key) => (
                            <React.Fragment key={key}>
                              <option value="" hidden disabled />
                              <option value={item[otherProps.valueKey || 'value']}>
                                {item[otherProps.labelKey || 'label']}
                              </option>
                            </React.Fragment>
                          ))}
                        </select>
                        <div className={cx('SelectField__arrow')} />
                      </div>
                    )}
                  </>
                )}
              </FormattedMessage>
            )}
          </FormattedMessage>
          {children}
        </div>
        {description && <div className={cx('SelectField__description')}> {description} </div>}
      </div>
    );
  }
}

const connector = connect(
  state => ({
    isPhone: state.responsive.isPhone || false,
  }),
  null,
);

export default connector(SelectField);

SelectField.defaultProps = {
  className: '',
  label: '',
  required: false,
  isSearchable: false,
  meta: {},
  description: '',
  onSelect: () => null,
  onChange: () => null,
  _ref: null,
};

SelectField.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  meta: PropTypes.object,
  name: PropTypes.string,
  description: PropTypes.string,
  required: PropTypes.bool,
  children: PropTypes.any,
  _ref: PropTypes.object,
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  options: PropTypes.array,
  isSearchable: PropTypes.bool,
  isPhone: PropTypes.bool,
};
